<template>
  <v-btn
    icon
    :class="['event-favorite', { 'event-favorite--tile': tile, 'event-favorite--selected': selected }]"
    :color="selected ? 'error' : undefined"
    variant="text"
    :size="tile ? 44 : 'small'"
    :disabled="!favorites.available"
    :aria-label="t(selected ? 'shell.eventSwitcher.removeFavorite' : 'shell.eventSwitcher.addFavorite', { name: title })"
    :aria-pressed="selected"
    @click.stop="favorites.toggle(clubId, seasonId, eventId)"
  >
    <svg class="event-favorite__heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 21s-9-5.7-9-12a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6.3-9 12-9 12Z" />
    </svg>
  </v-btn>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useEventFavoritesStore } from '@/stores/eventFavorites'
const props = defineProps<{ clubId: string; seasonId: string; eventId: string; title: string; tile?: boolean }>()
const { t } = useI18n()
const favorites = useEventFavoritesStore()
const selected = computed(() => favorites.isFavorite(props.clubId, props.seasonId, props.eventId))
</script>

<style scoped>
.event-favorite__heart { width: 26px; height: 26px; fill: #757575; stroke: white; stroke-width: 1.8; stroke-linejoin: round; }
.event-favorite--selected .event-favorite__heart { fill: rgb(var(--v-theme-error)); }
.event-favorite--tile { position: absolute; top: 8px; left: 8px; z-index: 3; }
.event-favorite--tile .event-favorite__heart { filter: drop-shadow(0 1px 2px rgb(0 0 0 / 35%)); }
.event-favorite:focus-visible { outline: 2px solid var(--cs-action); outline-offset: 2px; }
.event-favorite--tile:focus-visible { outline-color: white; }
</style>
